module.exports = __webpack_public_path__ + "img/women.543711cd.png";